import { createFileRoute, redirect, useNavigate, useParams } from '@tanstack/react-router';
import { Loader } from '@components/loader';
import { outletNavScroll } from '@utils/apiHelpers';
import { useEffect } from 'react';
import { OrdersPreview } from '@pages/orders/preview';
import { useListMerchantOrders } from '@services/staff/merchant/orders/list';

const MerchantOrders = () => {
  const navigate = useNavigate();
  const { merchantId, localId } = useParams({
    from: '/u/$localId/_staff/staff/merchants/$merchantId/orders',
  });
  const { orders, loading } = useListMerchantOrders(merchantId);
  const handleSelect = (id: string) => {
    navigate({
      to: '/u/$localId/staff/orders/$id',
      params: { id, localId },
    }).catch((err) => console.error(err));
  };

  useEffect(() => {
    outletNavScroll();
  }, []);

  if (loading) return <Loader />;

  return (
    <OrdersPreview
      onSelect={handleSelect}
      orders={orders}
      onViewMore={() => {
        navigate({
          to: '/u/$localId/staff/orders',
          params: { localId },
          /* eslint-disable camelcase */
          search: { merchant_id: merchantId },
        }).catch((err) => console.error(err));
      }}
    />
  );
};

export const Route = createFileRoute('/u/$localId/_staff/staff/merchants/$merchantId/orders')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['orders_read'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: MerchantOrders,
});
